const App = () => import('@/app/constellationPro/App.vue');
const Boards = () => import('@/app/constellationPro/pages/Boards.vue');

const PAGE_LEVEL_TOP = 'Constellation Pro';

export default {
  path: 'constellation-pro',
  component: App,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: 'constellation-pro',
      path: '',
      redirect: { name: 'constellation-pro.boards' },
    },
    {
      name: 'constellation-pro.boards',
      path: 'boards',
      component: Boards,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Boards`,
      },
    },
  ],
};
